import type { AdScene } from '@/app/types';

/**
 * Google Publisher Tag (GPT) 脚本地址
 */
export const GPT_SCRIPT_URL = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

/**
 * Google Ad Manager 配置
 */
export const GAM_CONFIG = {
  /** Network ID */
  NETWORK_ID: '23331291468', // 生产环境
  /** 广告单元名称 */
  AD_UNIT_NAME: 'Vidu_Reward_Ads_Display', // 生产环境
  /** 奖励类型 */
  REWARD_TYPE: 'credits',
} as const;

/**
 * 插页广告配置
 */
export const INTERSTITIAL_AD_CONFIG = {
  /** 插页广告单元路径 */
  AD_UNIT_PATH: '/23331291468/vidu_intersitial_1',
} as const;

/**
 * 广告事件名称
 */
export const AD_EVENTS = {
  /** 广告准备就绪 */
  READY: 'rewardedSlotReady',
  /** 奖励已发放 */
  GRANTED: 'rewardedSlotGranted',
  /** 广告已关闭 */
  CLOSED: 'rewardedSlotClosed',
  /** 广告渲染结束 */
  RENDER_ENDED: 'slotRenderEnded',
} as const;

/**
 * 插页广告相关事件（PubAdsService 通用事件）
 */
export const INTERSTITIAL_AD_EVENTS = {
  /** 广告位可见性变化（用户关闭插页时触发） */
  SLOT_VISIBILITY_CHANGED: 'slotVisibilityChanged',
} as const;

/**
 * 广告奖励积分
 */
export const AD_REWARD_CREDITS = 4;

/**
 * 各种场景对应的埋点上报
 */
export const AD_SCENE_FROM_PAGE_MAP: Record<AdScene, string> = {
  watch_ad_credit: 'insuffcient_credits_ad_popup',
  watch_ad_watermark: 'remove_watermark_ad_popup',
  open_screen_ads: 'splash_ad_popup',
  continue_earn_credits: 'countinue_earn_credits',
  task_center: 'task_system',
  sidebar_bottom: 'sidebar_bottom',
} as const;
